import React from 'react';
import PropTypes from 'prop-types';

import HeaderLogo from 'components/consumer/consumer-header/header-logo';
import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';

const CheckoutLoader = ({ isCartEmpty }) => (
  <div className="checkout checkout--loader component desktop checkout-component-desktop m-auto min-h-[calc(100vh_-_233px)] md:min-h-[calc(100vh_-_186px)] [&_span]:!font-sans min-h-screen">
    <div className="md:flex md:flex-row md:flex-[1_0_auto]">
      <div className="CheckoutStages__content items-center flex flex-[1_1_0] flex-col mr-auto max-w-[60rem] pt-0 px-0 pb-4 w-full min-[500px]:pt-0 min-[500px]:px-8 min-[500px]:pb-8 lg:pt-4 lg:pr-8 lg:pb-20 lg:pl-16 xl:pl-16">
        <div className="w-full flex flex-col min-[1440px]:flex-row">
          <div className="mx-0 my-4 max-[500px]:px-4 max-[500px]:py-0 lg:flex lg:flex-[0_0_auto] lg:justify-center lg:m-0 lg:w-[9.5rem] xl:justify-start">
            <HeaderLogo />
          </div>
        </div>

        {!isCartEmpty ? (
          <div className="w-full min-[1440px]:flex-[1_0_auto] min-[1440px]:pl-[9.5rem] max-[500px]:p-[0_1rem]">
            <div className="loader summary-loader w-full flex items-center justify-center flex-col mt-40">
              <ProgressLoader />
            </div>
          </div>
        ) : (
          'Cart Empty!'
        )}
      </div>

      <div className="CheckoutStages__sidebar bg-gray-light9 [border-left:1px_solid_#e5e5e5] text-gray-light1 px-4 py-8 min-[500px]:px-8 min-[500px]:py-12 md:max-w-[40rem] md:min-w-[19rem] md:px-6 md:py-[5.5rem] md:w-[38%] lg:pr-12 xl:pr-16 xl:pl-16" />
    </div>
  </div>
);

CheckoutLoader.propTypes = {
  isCartEmpty: PropTypes.bool,
};

export default CheckoutLoader;
